/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CopyIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 18 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="17.5 20.5 3.5 20.5 3.5 0.5 11.5 0.5 17.5 6.5" />
      <polyline points="11.5 0.5 11.5 6.5 17.5 6.5" />
      <polyline points="14.5 20.5 14.5 23.5 0.5 23.5 0.5 3.5 3.5 3.5" />
    </g>
  </svg>
);

export default CopyIcon;
